import Vue from 'vue';

export const toastBus = new Vue();

let seq = 0;

/**
 * Показать пользователю всплывающее уведомление.
 * @param {string} message
 * @param {'error'|'info'|'success'} type
 * @param {number} timeout мс; 0 — не скрывать автоматически
 */
export function toast(message, type = 'error', timeout = 5000) {
  toastBus.$emit('toast', { id: ++seq, message, type, timeout });
}
